import { makeStyles } from '@material-ui/core'

export const useChatStyles = makeStyles(theme => ({
  chatContainer: {
    overflowY: 'auto',
    marginBottom: 20,
    paddingTop: 20,
    height: '100vh',
    maxHeight: 617,
    flexWrap: 'nowrap'
  }
}))
